import { Component, ViewEncapsulation } from '@angular/core';
import { Category } from '../../models/categories/categories.model';
import { CommunicationService } from '../../shared/services/communication.service';

import { ApiService } from '../../shared/services/api.service';
import { ListBase } from '../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-product-category-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ProductCategoryListComponent extends ListBase<Category> {

  public url = 'product-categories';
  public routePrefix = 'categories';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }

}
